/*******************************************************************
* PAGE        : ErrorBoundary
* REMARKS     : Comman Error Boundary Component
* CREATED ON  : 13-11-2025
* AUTHOR      : Bamroliya.Paras
* MODIFY      : Bamroliya.Paras
* MODIFY ON   : 14-02-2026
********************************************************************/

import React, { Component } from 'react';
import './errorBoundary.css'
import { Images } from '../../utils/Images';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state to render fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can log error information to an external service here
    console.error("Error caught in ErrorBoundary:", error, errorInfo);
    this.setState({ error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      // this.state.error && this.state.error.toString();
      return (<div className="error-boundary-container" />);
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
